import { Title } from "@vshp/ui-components";
import educationBg from "../../../public/images/hero.jpg";
import Link from "next/link";
import Image from "next/image";

function Education({ slug }) {
  return (
    <section className="page__block page__block_cover page__block_center page__block_cover_light">
      <Image className="page__block-img" src={educationBg} alt="Обучение" placeholder="blur" />
      <div className="page__block-body">
        <Title type="h2" decor={false}>
          Обучение
        </Title>

        <div className="page__block-subtitle">В данном разделе находится подробная информация, которая пригодится в процессе обучения.</div>
        <Link className="btn btn_primary" href={slug}>
          Обучение
        </Link>
      </div>
    </section>
  );
}

export default Education;
